import apiClient from './client';
import {
  API_AUTH_API_TOKEN_ENDPOINT,
  API_AUTH_LANGUAGE_ENDPOINT,
  API_AUTH_PROFILE_ENDPOINT,
} from './config';

export interface ApiTokenResponse {
  api_token: string;
  token_type: 'bearer';
}

export type UserLanguage = 'en' | 'es';

export interface UserProfileResponse {
  username: string;
  company_name: string;
  language: UserLanguage;
  role: 'admin' | 'operator';
  operator_id: number | null;
  operator_name: string | null;
}

export interface UserLanguageResponse {
  language: UserLanguage;
}

export async function createApiToken(): Promise<ApiTokenResponse> {
  const response = await apiClient.post<ApiTokenResponse>(API_AUTH_API_TOKEN_ENDPOINT);
  return response.data;
}

export async function getCurrentUserProfile(): Promise<UserProfileResponse> {
  const response = await apiClient.get<UserProfileResponse>(API_AUTH_PROFILE_ENDPOINT);
  return response.data;
}

export async function getCurrentUserLanguage(): Promise<UserLanguageResponse> {
  const response = await apiClient.get<UserLanguageResponse>(API_AUTH_LANGUAGE_ENDPOINT);
  return response.data;
}

export async function updateCurrentUserLanguage(
  language: UserLanguage
): Promise<UserLanguageResponse> {
  const response = await apiClient.patch<UserLanguageResponse>(
    API_AUTH_LANGUAGE_ENDPOINT,
    { language }
  );
  return response.data;
}
